module.exports = __webpack_public_path__ + "img/zizhi10.7e4932c2.png";